import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    isOpen: false,
    modalType: null,
    modalProps: {},
};
export const modalGenSlice = createSlice({
    name: 'modal',
    initialState,
    reducers: {
        openModal: (state, action) => {
            state.isOpen = true;
            state.modalType = action.payload.modalType;
            state.modalProps = action.payload.modalProps;
        },
        closeModal: (state) => {
            state.isOpen = false;
            state.modalType = null;
            state.modalProps = {};
        },
    },
});
export const { openModal, closeModal } = modalGenSlice.actions;
export default modalGenSlice.reducer;
